module.exports = __webpack_public_path__ + "img/1-md.6cb17239.jpg";